<template>
  <div class="homework-student-statis">
    <div class="homework-statis-head">
      <div class="total-wrapper f-left">
        <p class="title">{{homeworkData.homework_name}}</p>
        <p class="info-line">所属课程信息：{{homeworkData.title}}</p>
        <p
          class="info-line"
        >作业时间：{{homeworkData.created_at | tsFormat('yyyy.MM.dd hh:mm:ss')}} ~ {{homeworkData.end_time | tsFormat('yyyy.MM.dd hh:mm:ss')}}</p>
        <p class="info-line">
          <span style="margin-right:30px;">
            <span>作业时长：</span>
            <span v-if="homeworkData.limit_time == -1">无限制</span>
            <span v-else>
              <span class="num">{{parseInt(homeworkData.limit_time / 60)}}</span>
              <span>分钟</span>
            </span>
          </span>
          <span>
            <span>满分：</span>
            <span class="num-red">{{homeworkData.score}}</span>
            <span>分</span>
          </span>
        </p>
        <p class="info-line">
          <span>作业题目数：</span>
          <span class="num space">{{homeworkData.objective_sum}}</span>
          <span>道客观题</span>
          <span class="num space">{{homeworkData.subjective_sum}}</span>
          <span>道主观题</span>
        </p>
        <div class="introduce">
          <span>作业说明：</span>
          <p class="desc extend">{{homeworkData.homework_introduce}}</p>
        </div>
      </div>
      <i-circle class="f-left" :percent="parseInt(homeworkData.submit_ratio)">
        <span>提交率</span>
        <span>{{homeworkData.submit_ratio}}</span>
      </i-circle>
    </div>
    <div class="statis-wrapper">
      <p class="section-title">答题统计</p>
      <div class="homework-count-box">
        <i class="el-icon-info"></i>
        <span>该部分有</span>
        <span class="num space">{{getQuesCount(-1)}}</span>
        <span>道题，其中{{getQuesCount(1)}}道单选题、{{getQuesCount(2)}}道判断题、{{getQuesCount(3)}}道多选题、{{getQuesCount(5)}}道简答题，总分为</span>
        <span class="num space">{{getQuesScore(-1)}}</span>
        <span>分</span>
      </div>
      <Table :columns="columns" :data="tableData"></Table>
    </div>
  </div>
</template>

<script>
export default {
  name: "homework-student-statis",
  data() {
    return {
      hw_id: this.$route.query.hwId,
      report_id: this.$route.query.reportId,
      columns: [
        {
          title: "题型",
          key: "name",
          align: "center"
        },
        {
          title: "正确题目数",
          key: "right_amount",
          align: "center"
        },
        {
          title: "题目数",
          key: "total",
          align: "center"
        },
        {
          title: "总分值",
          key: "total_score",
          align: "center"
        },
        {
          title: "得分值",
          key: "right_score",
          align: "center"
        },
        {
          title: "正确率",
          key: "correct_rate",
          align: "center"
        }
      ],
      tableData: [
        {
          name: "单选题",
          ques_type: 1,
          right_amount: 0,
          total: 0,
          total_score: 0,
          right_score: 0,
          correct_rate: 0
        },
        {
          name: "多选题",
          ques_type: 2,
          right_amount: 0,
          total: 0,
          total_score: 0,
          right_score: 0,
          correct_rate: 0
        },
        {
          name: "判断题",
          ques_type: 3,
          right_amount: 0,
          total: 0,
          total_score: 0,
          right_score: 0,
          correct_rate: 0
        },
        {
          name: "简答题",
          ques_type: 5,
          right_amount: 0,
          total: 0,
          total_score: 0,
          right_score: 0,
          correct_rate: 0
        }
      ],
      homeworkData: {}
    };
  },
  created() {
    this.requestStatisData();
  },
  methods: {
    // other
    // 获取题目数 quesType = -1 表示全部
    getQuesCount(quesType) {
      let ret = 0;
      this.tableData.forEach(i => {
        if (quesType == -1 || i.ques_type == quesType) {
          ret += +i.total;
        }
      });
      return ret;
    },
    // 获取分数 quesType = -1 表示全部
    getQuesScore(quesType) {
      let ret = 0;
      this.tableData.forEach(i => {
        if (quesType == -1 || i.ques_type == quesType) {
          ret += +i.total_score;
        }
      });
      return ret;
    },
    // request
    async requestStatisData() {
      let data = await this.$http.get(
        `/api/classHomework/questionType/statistics/${this.hw_id}/${this.report_id}`
      );
      if (data.statistics) {
        this.tableData.forEach(ci => {
          let statis;
          if (ci.ques_type == 1) {
            statis = data.statistics.single_choice;
          } else if (ci.ques_type == 2) {
            statis = data.statistics.multi_choice;
          } else if (ci.ques_type == 3) {
            statis = data.statistics.judge;
          } else if (ci.ques_type == 4) {
            statis = data.statistics.connection;
          } else if (ci.ques_type == 5) {
            statis = data.statistics.subjective;
          }
          ci.right_amount = statis.right;
          ci.total = statis.total;
          ci.total_score = statis.score;
          ci.right_score = statis.point;
          if (ci.total) {
            ci.correct_rate =
              parseInt((ci.right_amount / ci.total) * 100) + "%";
          }
        });
      }
      this.homeworkData = data;
    }
  }
};
</script>

<style lang="scss" scoped>
.homework-statis-head {
  overflow: hidden;
  /deep/ {
    .ivu-chart-circle {
      margin-left: 20px;
      margin-top: 30px;
    }
  }
  .total-wrapper {
    background-color: #fff;
    padding: 24px 32px;
    font-size: 14px;
    font-weight: 400;
    color: #595959;
    position: relative;
    .progress-wrapper {
      position: absolute;
      top: 60px;
      right: 32px;
      .progress {
        margin-left: 50px;
        display: inline-block;
        position: relative;
        .text {
          position: absolute;
          text-align: center;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          span:nth-of-type(1) {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.45);
          }
          span:nth-of-type(2) {
            font-size: 24px;
            color: rgba(0, 0, 0, 0.85);
          }
        }
      }
    }
    .info-line {
      margin: 10px 0;
    }
    .title {
      font-size: 16px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      margin-top: 0;
      margin-bottom: 20px;
      padding: 0;
      &::before {
        display: none;
      }
    }
    .introduce {
      display: flex;
      .desc {
        max-width: 400px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 5px;
        &.extend {
          max-width: 600px;
          overflow: unset;
          white-space: normal;
        }
      }
      .btn-show-all {
        color: $primary-color;
        cursor: pointer;
      }
    }
  }
  .count-wrapper {
    background-color: #fff;
    border-top: 1px solid #e9e9e9;
    display: flex;
    justify-content: space-around;
    padding: 24px 0;
    p {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      width: 100%;
      span:nth-of-type(1) {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
      }
      span:nth-of-type(2) {
        font-size: 24px;
        color: $primary-color;
      }
      &::after {
        content: "";
        display: block;
        width: 1px;
        height: 58px;
        background-color: #e8e8e8;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
      &:last-child::after {
        display: none;
      }
    }
  }
  .num {
    color: #4169ff;
    font-weight: 500;
  }
  .num-red {
    color: #ee1f1f;
    font-weight: 500;
  }
  .space {
    margin: 0 5px;
  }
}
.homework-count-box {
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  background: rgba(65, 105, 255, 0.02);
  border-radius: 4px;
  border: 1px solid rgba(65, 105, 255, 0.21);
  font-size: 14px;
  color: #595959;
  margin-bottom: 16px;
}
.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #262626;
  position: relative;
  padding-left: 10px;
}
.section-title::before {
  content: "";
  display: block;
  width: 3px;
  height: 14px;
  background-color: #4169ff;
  position: absolute;
  top: 50%;
  left: 0;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.homework-student-statis {
  .statis-wrapper {
    background-color: #fff;
    padding: 24px;
    margin-top: 30px;
    .homework-count-box {
      margin-top: 20px;
    }
  }
}
</style>
